import { render, staticRenderFns } from "./ClientAdd.vue?vue&type=template&id=53a16d3a&scoped=true"
import script from "./ClientAdd.vue?vue&type=script&lang=js"
export * from "./ClientAdd.vue?vue&type=script&lang=js"
import style0 from "./ClientAdd.vue?vue&type=style&index=0&id=53a16d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a16d3a",
  null
  
)

export default component.exports